<template>
  <input class="otp-input"
    v-model="digit"
    type="text"
    spellcheck="false"
    inputmode="numeric"
    :maxlength="1"
    @input="checkInput"
    @paste="$event => $emit('paste', $event)"
    @blur="$event => $emit('blur', $event)"
    @keydown="handleKeydown"
  />
</template>

<script>
export default {
  name: 'otp-group-input',

  props: {
    value: String,
  },

  data() {
    return {
      digit: '',
      skipNextInput: false,
    };
  },

  watch: {
    value() {
      this.setInitialValue();
    },

    digit(newValue, oldValue) {
      if (newValue !== oldValue) {
        if ('' === newValue) {
          this.emitPrev();
        } else {
          this.emitNext();
        }
      }
    },
  },

  methods: {
    emitPrev() {
      this.$emit('prev');
    },
    emitNext() {
      this.$emit('next');
    },

    setInitialValue() {
      switch (typeof this.value) {
      case 'string':
        this.digit = this.value;
        break;
      case 'number':
        this.digit = this.value?.toString();
        break;

      default:
        this.digit = this.value?.data ? this.value?.data : '';
        break;
      }
    },
    checkInput(event) {
      this.$emit('input', event)
    },
    handleKeydown(event) {
      if ('Backspace' === event.key && '' === this.digit) {
        this.emitPrev()
        event.preventDefault();
        event.stopPropagation();
      }
    },
  },
}
</script>
